module.exports = __webpack_public_path__ + "img/12.d23a5b54.jpeg";